import React from 'react';
import ReactDOM from 'react-dom';
import InfiniteScroll from '../InfiniteScroll';
import Post from '../Models/Post';

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state =  {
      pagetype: '',
      endpoint: 'post/',
      urlStructure: '%domain%%url%',
    };
  }

  componentDidMount() {
    this.getInitialState();
  }

  getInitialState() {
    this.setState(() => ({  
      pagetype: 'home',
    }));
  }

  getSeoDataArray(post) {
    let seoDataArray = [];

    if (!post) {
      return seoDataArray;
    }
    
    const seoData = post.meta_data.seoData;
    const socialData = post.meta_data.socialData;

    seoDataArray['og:title'] = socialData.social_title ?? '';
    seoDataArray['og:description'] = socialData.social_description ?? '';
    seoDataArray['og:url'] = socialData.social_url ?? '';
    seoDataArray['og:image'] = socialData.social_image ?? '';

    seoDataArray['twitter:title'] = socialData.social_title ?? '';
    seoDataArray['twitter:description'] = socialData.social_description ?? '';
    seoDataArray['twitter:image'] = socialData.social_image ?? '';

    seoDataArray['article:published_time'] = post.created_at ?? '';
    seoDataArray['article:modified_time'] = post.modified ?? '';
    seoDataArray['article:author'] = seoData.seo_author_name ?? '';
    seoDataArray['article:section'] = seoData.seo_category_name ?? '';
    seoDataArray['article:tag'] = seoData.seo_tags ?? '';
    seoDataArray['profile:first_name'] = seoData.seo_author_first_name;
    seoDataArray['profile:last_name'] = seoData.seo_author_last_name ?? '';

    seoDataArray['aller_ga'] = seoData.aller_ga ?? {};

    return seoDataArray;
  }

  getEndpoint(post){
    if (post) {
      if (post[0].previous == false) {
        return false;
      }
      return `/api/${this.endpoint}${post[0].previous['id']}/`;
    }
    return `/api/${this.endpoint}${window.post.id}/`;
  }

  render() {
    return (
      <InfiniteScroll 
        pageId={1} 
        urlStructure={this.state.urlStructure} 
        perPage={1} 
        endpoint={this.state.endpoint} 
        pagetype={this.state.pagetype}
        getSeoDataArray={this.getSeoDataArray}
        getEndpoint={this.getEndpoint}
        >
        <Post />
      </InfiniteScroll>
    )
  } 

}
let homeElement = document.getElementById('home')
if (homeElement) {
  ReactDOM.render(<HomePage/>, homeElement);
}